import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
      <div class="poem">

        <p class="mb-3 text-center bold">* * *</p>
        
        <p class="poem-block mb-3">
          Jen la venk’ super tuta mond’:<br/>
          Venas nova potenca ond’<br/>
          Por la pura feliĉa ter’:<br/>
          Liberigi nin de mizer’,<br/>
          Ĝin forlavi de tersurfac’<br/>
          Por ke l’ resto vivu en pac’!<br/>
          Kia ĝoj’! Nek brutar’, nek uzin’,<br/>
          Nur de l’ purenergio domin’,<br/>
          Nur por ni pura oksigen’! <br/>
          Vi, povruloj, vi restu sen,<br/>
          Ĉar vi, stulta malpura hord’,<br/>
          Ne deziras vivi en ord’, <br/>
          Kiun saĝe instalis ni – <br/>
          Tiam mortu en agoni’!
        </p>
      </div>
    `
  )
}

const itemName = {
  esp: 'Jen la venk’'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}


export default item;